import { jsxs as r, Fragment as i, jsx as o } from "react/jsx-runtime";
import { c as n } from "../../index-C7ezJk5b.js";
import { I as e } from "../../search-CKuQy5LF.js";
import { b as m } from "../../base-BUIxijjU.js";
import "react";
import { cssX as t, cssTI as c } from "../../core/utils/css.js";
import "react-dom";
import p from "../../components/Tooltip/Tooltip.js";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const I = () => {
  const { globalSearch: { setIsOpened: a } } = m();
  return /* @__PURE__ */ r(i, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: n(t("PlatformNavigation__button"), t("Icon")),
        id: t("platform-navigation-search-button"),
        "data-tooltip-id": t("platform-navigation-search-tooltip"),
        "data-testid": c("button", "PlatformNavigationSearch"),
        onClick: () => a(!0),
        children: /* @__PURE__ */ o(e, {})
      }
    ),
    /* @__PURE__ */ o(
      p,
      {
        id: t("platform-navigation-search-tooltip"),
        place: "left",
        children: "Snap Search"
      }
    )
  ] });
};
export {
  I as default
};
